import { render, staticRenderFns } from "./PRF101P03.vue?vue&type=template&id=0fee8110&"
import script from "./PRF101P03.vue?vue&type=script&lang=js&"
export * from "./PRF101P03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports